export function canonicalUrl(path) {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  return `${window.location.origin}${pathname}`
}

export function canonicalLink(path) {
  return { rel: 'canonical', href: canonicalUrl(path), key: 'canonical' }
}
